import { Component, OnInit, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { ErrorFormatter } from '../../helpers/error-formatter';
import { PeopleService } from '@core/state/people/people.service';
import { AccountService } from '@core/state/account';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-modal-contact-form',
  templateUrl: './modal-contact-form.component.html',
  styleUrls: ['./modal-contact-form.component.scss']
})
export class ModalContactFormComponent implements OnInit {
  @ViewChildren('ionItem', { read: ElementRef }) ionItems:  QueryList<any>;

  private subs = new Subscription();

  // "modal" property from parent will inherited here
  public modal: any;

  form = {
    question: null,
    response: null,
    person_id: null,
  };
  submitting = false;
  submitted = false;

  err = new ErrorFormatter();

  constructor(
    private peopleService: PeopleService,
    public account: AccountService,
  ) { }

  ionViewDidEnter() {
    this.subs.add(
      this.account.get().subscribe(data => {
        this.form.person_id = data.id;
      })
    );
  }

  ngOnInit() {
    setTimeout(()=>{
      if(this.ionItems) {
        const ionItems = this.ionItems.toArray();
  
        ionItems.forEach(ionItem => {
          const itemInner = ionItem.nativeElement.shadowRoot.querySelector('.item-inner');
          itemInner.style.borderBottom = 'none';
        });   
      }
    });
  }

  submit() {
    
    this.submitting = true;
    this.modal.backdropDismiss = false;

    this.peopleService.submitContactRequest(this.form).subscribe(
      (data) => {
        this.submitted = true;
        this.submitting = false;
        this.modal.backdropDismiss = true;
        console.log(data);
      },
      (errors) => {
        this.submitting = false;
        this.modal.backdropDismiss = true;
        this.err = new ErrorFormatter(errors['error']);
      }
    );
  }
}
